import axios from 'axios';

const api = axios.create({
    baseURL: 'https://conselho.gremio.net/index.php'
    //baseURL: 'http://localhost:8080/index.php'
});

api.interceptors.request.use(async config => {
    const token = localStorage.getItem('ac');
    if (token) {
        config.headers.Authorization = `bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use( (response) => {
    return response;
}, async (error) => {
    if (401 === error.response.status) {
        console.log('Unauthenticated');
        localStorage.removeItem('ac');
        // window.location = '/pwa/#/login';
        window.location = '/GrApPmIo/#/login';
    } else {
        return Promise.reject(error);
    }
});

export default api;